import { SxProps } from '@mui/material';
import { FC, useState, useEffect } from 'react';
import { DpRenderCatalogEntryCarouselHeader } from '@/components/blocks/DpRenderCatalogEntryCarouselHeader';
import { DpRenderCatalogsEntryRecommendation } from '@/components/blocks/DpRenderCatalogsEntryRecommendation';

type Props = {
	title: string;
	href?: string;
	titlesx?: SxProps;
	framesx?: SxProps;
	catalogs: Array<{
		name: string;
		spot: string;
		moreHref?: string | undefined;
	}>;
};

export const DpRenderCatalogsEntry: FC<Props> = ({ title, href, catalogs, titlesx, framesx }) => {
	const [selected, setSelected] = useState<string>('');

	const handleSelected = (activeId: string) => {
		setSelected(activeId);
	};

	useEffect(() => {
		if (catalogs.length > 0 && !selected) {
			setSelected(catalogs[0].spot);
		}
	}, [catalogs, selected]);

	return (
		<>
			<DpRenderCatalogEntryCarouselHeader
				title={title}
				href={href}
				buttons={catalogs}
				titlesx={titlesx}
				framesx={framesx}
				activeSpot={selected}
				onSpotSelected={handleSelected}
			/>
			<DpRenderCatalogsEntryRecommendation currentSpot={selected} catalogs={catalogs} />
		</>
	);
};
